module.exports = __webpack_public_path__ + "media/images/logos/yahoo-news-logo-366d109f8fd29129041460e6fda1a2df.png";